import React from 'react';
import { useIntl } from 'react-intl';
import { SearchBarContainerWithProviders } from '@eventbrite/consumer-search.search-bar';
import classNames from 'classnames';
import { GlobalNavProvider } from '../../state';
import { GlobalNavProps } from '../../types';

import styles from './ConsumerHeaderSearchBar.module.scss';

export interface SearchBarLayoutProps {
    children: React.ReactNode;
    variant?: 'globalNav' | 'consumerHeader';
    wrapperProps?: React.ComponentPropsWithoutRef<'div'> & {
        'data-testid'?: string;
    };
}

export const SearchBarLayout: React.FC<SearchBarLayoutProps> = ({
    children,
    variant = 'consumerHeader',
    wrapperProps = {},
}) => {
    const { formatMessage } = useIntl();
    const { className, ...restWrapperProps } = wrapperProps;
    const searchBarClassnames = classNames(
        styles.consumerHeaderSearchBar,
        styles.withSearchDropdown,
        variant === 'globalNav' ? styles.globalNavVariant : styles.consumerHeaderVariant,
        className,
    );
    return (
        <div className={searchBarClassnames} {...restWrapperProps}>
            <nav
                aria-label={formatMessage({
                    id: 'Main Navigation',
                    defaultMessage: 'Main Navigation',
                })}
                data-testid="consumer-header-nav"
            >
                {children}
            </nav>
        </div>
    );
};

export const ConsumerHeaderSearchBar: React.FC<GlobalNavProps> = ({ searchBar, user, env }) => {
    return (
        <GlobalNavProvider
            positionSticky={{ desktop: false, mobile: false }}
            searchBar={searchBar}
            user={user}
            env={env}
        >
            <SearchBarLayout variant="consumerHeader">
                <SearchBarContainerWithProviders
                    usesLanguageSubdirectory={env?.localeInfo?.uses_language_subdirectory || false}
                    locale={env?.localeInfo?.locale}
                    user={user}
                    location={searchBar?.location}
                    initialQuery={searchBar?.searchQuery}
                    chatbotEnabled={searchBar?.chatbotEnabled}
                    completionTypes={searchBar?.completionTypes}
                    onAutocompleteCallback={searchBar?.onAutocompleteCallback}
                    pageType={searchBar?.pageType}
                />
            </SearchBarLayout>
        </GlobalNavProvider>
    );
};
